export enum ResetStep {
  NOT_STARTED = 'NOT_STARTED',
  EMAIL = 'EMAIL',
  CODE = 'CODE',
  PASSWORD = 'PASSWORD',
  SUCCESS = 'SUCCESS',
}
